/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rap_Footer_MakeInputs */

const en_rap_footer_make = /** @type {(inputs: Rap_Footer_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make`)
};

/**
* | output |
* | --- |
* | "Make" |
*
* @param {Rap_Footer_MakeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const rap_footer_make = /** @type {((inputs?: Rap_Footer_MakeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rap_Footer_MakeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_rap_footer_make(inputs)
});
export { rap_footer_make as "rap.footer.make" }